var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"load-indicator"}},[_vm._m(0),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.text)+" loading...")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-spinner fa-pulse"})])
}]

export { render, staticRenderFns }